import EDC from '@/components/games/shared/globals';
/**
 *
 */
EDC.Games.NameSelect.LetterSlot = function (scene, parent) {
  this.scene = scene;
  this.parent = parent;
  this.slotImg = null;
  this.letter = null;
  return this;
};
/**
 *
 */
EDC.Games.NameSelect.LetterSlot.prototype.create = function (x, y, letter) {
  this.letter = letter;
  this.slotImg = this.scene.add.sprite(x, y, 'name-selection-spin-slot').setOrigin(0);
  this.letter = this.scene.add.text(this.slotImg.x + this.slotImg.width / 2,
    this.slotImg.y + this.slotImg.height / 2, letter, {
      fontFamily: 'Courier New',
      fontSize: 100,
      color: '#ffffff',
    }).setOrigin(0.5);
  this.parent.add([this.slotImg, this.letter]);

  return this;
};
/**
 *
 */
EDC.Games.NameSelect.LetterSlot.prototype.getWidth = function () {
  return this.slotImg.width;
};
/**
 *
 */
EDC.Games.NameSelect.LetterSlot.prototype.destroy = function () {
  this.parent.remove([this.slotImg, this.letter]);
  this.slotImg.destroy();
  this.letter.destroy();
};

export default EDC.Games.NameSelect.LetterSlot;
